import { Grid } from '@mui/material';
import { useCallback } from 'react';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import PmiTextField from 'shell/components/shared/text-field';
import { AccordionGeneralityFormVM } from 'front-office/view-models/certificate/generality-form';
import { FormikErrors, FormikTouched } from 'formik';
import MunicipalityForeignList from 'shell/components/shared/municipality-foreign-list';
import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';

interface ForeignStateProps {
  foreignStateBirth?: ForeignStateVM | null;
  foreignMunicipality?: MunicipalityAnprVM | null;
  onChange: (
    key: keyof AccordionGeneralityFormVM,
    value: AccordionGeneralityFormVM[keyof AccordionGeneralityFormVM]
  ) => void;
  errors?: FormikErrors<AccordionGeneralityFormVM>;
  touched?: FormikTouched<AccordionGeneralityFormVM>;
}

const ForeignState = ({
  onChange,
  foreignStateBirth,
  foreignMunicipality,
  errors,
  touched,
}: ForeignStateProps): React.ReactElement => {
  const onChangeForeignStateList = useCallback(
    (foreignState?: ForeignStateVM | null) => {
      onChange('foreignStateBirth', foreignState);
    },
    [onChange]
  );

  const onChangeForeignMunicipalityList = useCallback(
    (municipality) => {
      onChange('foreignMunicipality', municipality);
    },
    [onChange]
  );

  return (
    <Grid
      item
      container
      spacing={0}
      columnSpacing={{ xs: 0, md: 1 }}
      rowSpacing={1}
      xs={12}
      alignItems="center"
    >
      <Grid item xs={12} md={4}>
        <ForeignStateList
          value={foreignStateBirth || null}
          onChange={onChangeForeignStateList}
          label="Stato estero di nascita *"
          id="foreignStateBirth"
          error={touched?.foreignStateBirth && Boolean(errors?.foreignStateBirth)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <MunicipalityForeignList
          value={foreignMunicipality || null}
          onChange={onChangeForeignMunicipalityList}
          label="Comune estero *"
          id="foreignMunicipality"
          disabled={!foreignStateBirth}
          foreignStateIstatCode={foreignStateBirth?.id}
          error={touched?.foreignMunicipality && Boolean(errors?.foreignMunicipality)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Provincia o Contea"
          label="Provincia/Contea"
          id="foreignProvince"
          name="foreignProvince"
          fullWidth
          type="text"
          disabled
          variant="outlined"
          value={foreignMunicipality?.province || ''}
        />
      </Grid>
    </Grid>
  );
};

ForeignState.displayName = 'Foreign State component';

export default ForeignState;
